import Vue from 'vue';

const focusFirstInput = (ref, ctx) => {
  setTimeout(() => {
    ctx.$refs[ref]?.focus()
  }, 350);
}

Vue.prototype.focusFirstInput = focusFirstInput
